




















import { defineComponent, toRefs, PropType, computed, ref, onMounted } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, ShopType, OptimizeGoal, fakeOptimizeGoal } from '@tt4b/ttam-enums';
import ALink from '@/components/common/a-link/a-link.vue';
import { useAllowlist, useStdAdgroupIs, useStore, useAdgroupIos14, useGetAmEntranceApi } from '@tt4b/ttam-hooks';

const name = 'ttam-attribution-tips';
export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    isShowAttributeSettingTips: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { adgroupData, campaignData } = toRefs(props);
    const { isIOS14Above } = useAdgroupIos14({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isWebsite, isAppDownload, isStandardAdsWithShop, isLiveAds, isStandardAdsWithShowcase } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value?.aadvid ?? '');
    const { isAttributionManagerAppWhite, isShopMultipleAttrWhite } = useAllowlist();

    const isAttributionManagerShopWhite = ref(false);
    const getEmTrance = async () => {
      try {
        const { showShop } = await useGetAmEntranceApi();
        isAttributionManagerShopWhite.value = showShop;
      } catch {
        isAttributionManagerShopWhite.value = false;
      }
    };

    const isShopSupportAttributionManager = computed(() => {
      const isConvertTypeOpt = [OptimizeGoal.CONVERT, OptimizeGoal.VALUE].includes(adgroupData.value.optimizeGoal);
      const isEcommShop = adgroupData.value.shopType === ShopType.ecommShop;

      // 1. 是转化类优化目标
      if (!isConvertTypeOpt) {
        return false;
      }
      // 2. 开了白
      if (!isAttributionManagerShopWhite.value) {
        return false;
      }
      // 3.1 shop flow - 1p
      if (isStandardAdsWithShop.value) {
        return isEcommShop;
      }
      // 3.2 live flow - 1p 或者支持混场归因时（不需要 shop）
      if (isLiveAds.value) {
        return isEcommShop || isShopMultipleAttrWhite.value;
      }
      // 3.3 showcase支持
      if (isStandardAdsWithShowcase.value) {
        return true;
      }

      return false;
    });

    const isTipVisible = computed(
      () => isWebsite.value || isAttributionManagerAppWhite.value || isShopSupportAttributionManager.value,
    );

    const attributionMangerLink = computed(() => {
      if (isWebsite.value) {
        return `/i18n/attribution-manager/?tab=web&referer=creation&aadvid=${aadvid.value}`;
      }
      if (isAppDownload.value) {
        return `/i18n/attribution-manager/?tab=app&referer=creation&&aadvid=${aadvid.value}`;
      }

      if (isStandardAdsWithShop.value || isLiveAds.value || isStandardAdsWithShowcase.value) {
        return `/i18n/attribution-manager/?tab=onsite&referer=creation&&aadvid=${aadvid.value}`;
      }

      return '';
    });

    onMounted(() => {
      getEmTrance();
    });

    return {
      name,
      isTipVisible,
      isIOS14Above,
      attributionMangerLink,
      isShopSupportAttributionManager,
    };
  },
});
